import httpService from '@/utils/request'
import { contextPath } from '@/config/'

export const queryScheduleRecordListApi = (params) => {
  return httpService({
    url: contextPath + '/spider/schedule/record/info',
    method: 'get',
    params
  })
}

export const queryScheduleRecordInfoApi = (params) => {
  return httpService({
    url: contextPath + '/spider/schedule/record/item',
    method: 'get',
    params
  })
}

export const querySpiderResultsApi = (params) => {
  return httpService({
    url: contextPath + '/parse/failed/web/info',
    method: 'get',
    params
  })
}

export const downloadLogApi = (params) => {
  return httpService({
    url: contextPath + '/spider/schedule/record/item/getLogByTaskId',
    method: 'get',
    params
  })
}

export const stopDispatchApi = (params) => {
  return httpService({
    url: contextPath + '/spider/schedule/record/item/killTaskById',
    method: 'put',
    params
  })
}
